(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alkaline-landing-header"] && !Shopify.designMode) return;
  try {
    
  if (!window.__alkalineLandingHeaderMenuHandler) {
    window.__alkalineLandingHeaderMenuHandler = true;

    const searchDialogSelector = '[data-alkaline-search-dialog]';
    const bodyOverflowDataKey = 'alkalineHeaderSearchOverflow';

    const isSearchDialog = (element) => element instanceof Element && element.matches(searchDialogSelector);
    const isSearchOpen = (dialog) => isSearchDialog(dialog) && (dialog.open || dialog.hasAttribute('open'));

    const trapFallbackFocus = (event, dialog) => {
      if (!dialog.dataset.alkalineSearchFallback || event.key !== 'Tab') return;
      const focusable = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter((element) => element.getClientRects().length > 0 && element.tabIndex >= 0);
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const activeElement = document.activeElement;
      if (event.shiftKey && (activeElement === first || !dialog.contains(activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (activeElement === last || !dialog.contains(activeElement))) {
        event.preventDefault();
        first.focus();
      }
    };

    const restoreBodyScroll = () => {
      const body = document.body;
      if (!body || document.querySelector(`${searchDialogSelector}[open]`)) return;
      const previousOverflow = body.dataset[bodyOverflowDataKey];
      if (typeof previousOverflow === 'undefined') return;
      body.style.overflow = previousOverflow;
      delete body.dataset[bodyOverflowDataKey];
      if (typeof body.dataset.alkalineSearchPadRight !== 'undefined') { body.style.paddingRight = body.dataset.alkalineSearchPadRight; delete body.dataset.alkalineSearchPadRight; }
    };

    const lockBodyScroll = () => {
      const body = document.body;
      if (!body || typeof body.dataset[bodyOverflowDataKey] !== 'undefined') return;
      body.dataset[bodyOverflowDataKey] = body.style.overflow;
      const sbw = window.innerWidth - document.documentElement.clientWidth;
      if (sbw > 0) { body.dataset.alkalineSearchPadRight = body.style.paddingRight || ''; body.style.paddingRight = sbw + 'px'; }
      body.style.overflow = 'hidden';
    };

    const finishSearchClose = (dialog) => {
      if (!isSearchDialog(dialog)) return;
      const predictiveSearch = dialog.querySelector('predictive-search');
      if (typeof predictiveSearch?.close === 'function') predictiveSearch.close(false);
      dialog.removeAttribute('aria-modal');
      delete dialog.dataset.alkalineSearchFallback;
      restoreBodyScroll();

      const opener = dialog.__alkalineSearchOpener;
      dialog.__alkalineSearchOpener = null;
      if (!(opener instanceof HTMLElement)) return;
      opener.setAttribute('aria-expanded', 'false');
      if (document.contains(opener)) {
        window.setTimeout(() => opener.focus({ preventScroll: true }), 0);
      }
    };

    const closeSearch = (dialog) => {
      if (!isSearchOpen(dialog)) return;
      if (!dialog.dataset.alkalineSearchFallback && typeof dialog.close === 'function') {
        try {
          dialog.close();
          return;
        } catch (error) {
          // Fall through to the attribute-based fallback below.
        }
      }
      dialog.removeAttribute('open');
      finishSearchClose(dialog);
    };

    const openSearch = (dialog, opener) => {
      if (!isSearchDialog(dialog)) return;
      if (isSearchOpen(dialog)) {
        dialog.querySelector('[data-alkaline-search-input]')?.focus({ preventScroll: true });
        return;
      }

      dialog.__alkalineSearchOpener = opener;
      opener?.setAttribute('aria-expanded', 'true');
      try {
        if (typeof dialog.showModal !== 'function') throw new Error('Native dialog is unavailable.');
        dialog.showModal();
      } catch (error) {
        dialog.dataset.alkalineSearchFallback = 'true';
        dialog.setAttribute('role', 'dialog');
        dialog.setAttribute('aria-modal', 'true');
        dialog.setAttribute('open', '');
      }

      lockBodyScroll();
      window.setTimeout(() => {
        if (!isSearchOpen(dialog)) return;
        dialog.querySelector('[data-alkaline-search-input]')?.focus({ preventScroll: true });
      }, 0);
    };

    const setCartDialogState = () => {
      if (!document.querySelector('cart-drawer')) return;
      document.querySelectorAll('.alkaline-header #cart-icon-bubble').forEach((cartLink) => {
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
      });
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const searchOpener = event.target.closest('[data-alkaline-search-open]');
      if (searchOpener) {
        event.preventDefault();
        const dialogId = searchOpener.getAttribute('aria-controls');
        const dialog = dialogId ? document.getElementById(dialogId) : null;
        openSearch(dialog, searchOpener);
        return;
      }

      const searchClose = event.target.closest('[data-alkaline-search-close]');
      if (searchClose) {
        event.preventDefault();
        closeSearch(searchClose.closest(searchDialogSelector));
        return;
      }

      const searchDialog = event.target.closest(searchDialogSelector);
      if (searchDialog && event.target === searchDialog) {
        closeSearch(searchDialog);
        return;
      }

      const menuLink = event.target.closest('[data-alkaline-menu-link]');
      menuLink?.closest('[data-landing-menu]')?.removeAttribute('open');

      // The native drawer listener is lost when Shopify replaces a header in the editor.
      // Already-handled clicks are ignored so the original listener never runs twice.
      const cartLink = event.target.closest('.alkaline-header #cart-icon-bubble');
      if (!cartLink || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const drawer = document.querySelector('cart-drawer');
      if (typeof drawer?.open !== 'function') return;
      event.preventDefault();
      drawer.open(cartLink);
    });

    document.addEventListener('close', (event) => {
      if (isSearchDialog(event.target)) finishSearchClose(event.target);
    }, true);

    document.addEventListener('cancel', (event) => {
      if (!isSearchDialog(event.target)) return;
      event.preventDefault();
      closeSearch(event.target);
    }, true);

    document.addEventListener('shopify:section:load', setCartDialogState);

    document.addEventListener('shopify:section:unload', (event) => {
      if (!(event.target instanceof Element)) return;
      event.target.querySelectorAll(searchDialogSelector).forEach(closeSearch);
      restoreBodyScroll();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setCartDialogState, { once: true });
    } else {
      setCartDialogState();
    }

    document.addEventListener('keydown', (event) => {
      const dialog = document.querySelector(`${searchDialogSelector}[open]`);
      if (event.key === 'Escape') {
        if (isSearchDialog(dialog)) {
          const predictiveSearch = dialog.querySelector('predictive-search[open]');
          if (predictiveSearch && typeof predictiveSearch.close === 'function') {
            event.preventDefault();
            predictiveSearch.close(false);
            dialog.querySelector('[data-alkaline-search-input]')?.focus({ preventScroll: true });
            return;
          }
          event.preventDefault();
          closeSearch(dialog);
          return;
        }
      }

      if (isSearchOpen(dialog)) trapFallbackFocus(event, dialog);

      if (!(event.target instanceof Element) || event.defaultPrevented || event.code !== 'Space') return;
      const cartLink = event.target.closest('.alkaline-header #cart-icon-bubble');
      const drawer = document.querySelector('cart-drawer');
      if (!cartLink || typeof drawer?.open !== 'function') return;
      event.preventDefault();
      drawer.open(cartLink);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-clearance-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ap-stock-ticker')) {
    customElements.define('ap-stock-ticker', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.viewport = this.querySelector('[data-stock-viewport]');
        this.track = this.querySelector('[data-stock-track]');
        this.source = this.querySelector('[data-stock-source]');
        this.toggle = this.querySelector('[data-stock-toggle]');
        if (!this.viewport || !this.track || !this.source || !this.toggle) return;
        this.initialized = true;
        this.listeners = [];
        this.manualPaused = false;
        this.hovered = false;
        this.focused = false;
        this.visible = true;
        this.running = false;
        this.frame = null;
        this.lastTime = null;
        this.speed = Math.max(10, Math.min(100, Number(this.dataset.speed) || 35));
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.tick = this.tick.bind(this);
        this.listen(this.toggle, 'click', () => { this.manualPaused = !this.manualPaused; this.updateState(); });
        this.listen(this.viewport, 'pointerenter', (event) => { if (event.pointerType !== 'touch') { this.hovered = true; this.updateState(); } });
        this.listen(this.viewport, 'pointerleave', () => { this.hovered = false; this.updateState(); });
        this.listen(this.viewport, 'pointerdown', () => this.pause(), { passive: true });
        this.listen(this.viewport, 'wheel', (event) => { if (Math.abs(event.deltaX) > Math.abs(event.deltaY) || event.shiftKey) this.pause(); }, { passive: true });
        this.listen(this.viewport, 'focusin', () => { this.focused = true; this.updateState(); });
        this.listen(this.viewport, 'focusout', (event) => { if (!this.viewport.contains(event.relatedTarget)) { this.focused = false; this.updateState(); } });
        this.listen(this.motion, 'change', () => this.rebuild());
        this.listen(document, 'visibilitychange', () => this.updateState());
        this.resizeObserver = new ResizeObserver(() => this.rebuild());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.source);
        this.visibilityObserver = new IntersectionObserver((entries) => { this.visible = entries[0].isIntersecting; this.updateState(); });
        this.visibilityObserver.observe(this.viewport);
        this.rebuild();
        document.fonts?.ready.then(() => { if (this.isConnected) this.rebuild(); });
      }

      listen(target, event, callback, options) {
        target.addEventListener(event, callback, options);
        this.listeners.push(() => target.removeEventListener(event, callback, options));
      }

      rebuild() {
        const width = this.source.getBoundingClientRect().width;
        const enhanced = this.dataset.autoScroll !== 'false' && !this.motion.matches && this.source.children.length > 1 && width > this.viewport.clientWidth;
        const signature = `${width}:${this.viewport.clientWidth}:${enhanced}`;
        if (this.layoutSignature === signature) return;
        this.layoutSignature = signature;
        this.stop();
        this.track.querySelectorAll('[data-stock-clone]').forEach((clone) => clone.remove());
        this.cycleWidth = width;
        this.enhanced = enhanced;
        if (enhanced) {
          const clone = this.source.cloneNode(true);
          clone.removeAttribute('data-stock-source');
          clone.setAttribute('data-stock-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('id');
          clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => element.removeAttribute('data-shopify-editor-block'));
          clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
          this.track.append(clone);
          this.viewport.scrollLeft %= width;
        }
        this.dataset.enhanced = String(enhanced);
        this.toggle.hidden = !enhanced;
        this.updateState();
      }

      pause() {
        this.manualPaused = true;
        this.updateState();
      }

      updateState() {
        this.toggle.textContent = this.manualPaused ? (this.dataset.resumeLabel || 'Resume') : (this.dataset.pauseLabel || 'Pause');
        this.toggle.setAttribute('aria-pressed', String(this.manualPaused));
        const shouldRun = this.enhanced && !this.manualPaused && !this.hovered && !this.focused && this.visible && !document.hidden;
        this.dataset.running = String(Boolean(shouldRun));
        if (shouldRun && !this.running) {
          this.running = true;
          this.position = this.viewport.scrollLeft % this.cycleWidth;
          this.lastTime = null;
          this.frame = requestAnimationFrame(this.tick);
        } else if (!shouldRun) {
          this.stop();
        }
      }

      tick(time) {
        if (!this.running) return;
        if (this.lastTime !== null) {
          const elapsed = Math.min((time - this.lastTime) / 1000, .05);
          this.position = (this.position + this.speed * elapsed) % this.cycleWidth;
          this.viewport.scrollLeft = this.position;
        }
        this.lastTime = time;
        this.frame = requestAnimationFrame(this.tick);
      }

      stop() {
        if (this.frame !== null) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.running = false;
        this.lastTime = null;
      }

      disconnectedCallback() {
        if (!this.initialized) return;
        this.stop();
        this.listeners.forEach((remove) => remove());
        this.resizeObserver.disconnect();
        this.visibilityObserver.disconnect();
        this.track.querySelectorAll('[data-stock-clone]').forEach((clone) => clone.remove());
        this.toggle.hidden = true;
        this.dataset.enhanced = 'false';
        this.dataset.running = 'false';
        this.layoutSignature = null;
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-popular-pairings"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ap-pair-form')) {
    customElements.define('ap-pair-form', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form || this.boundSubmit) return;
        this.button = this.form.querySelector('button[type="submit"]');
        this.label = this.querySelector('[data-pair-button-label]');
        this.message = this.querySelector('[data-pair-message]');
        this.boundSubmit = this.submitPair.bind(this);
        this.boundChange = this.updatePrice.bind(this);
        this.form.addEventListener('submit', this.boundSubmit);
        this.form.addEventListener('change', this.boundChange);
        if (document.querySelector('cart-drawer')) this.button.setAttribute('aria-haspopup', 'dialog');
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.boundSubmit);
        this.form?.removeEventListener('change', this.boundChange);
        this.boundSubmit = null;
      }

      updatePrice() {
        let total = 0;
        this.form.querySelectorAll('[data-pair-variant]').forEach((input) => {
          const price = input.tagName === 'SELECT' ? input.selectedOptions[0]?.dataset.price : input.dataset.price;
          total += Number(price || 0);
        });
        const percentage = Number(this.dataset.discountPercent || 0);
        const discountedTotal = Math.round(total * (100 - percentage) / 100);
        this.querySelector('[data-pair-original-total]').textContent = this.formatMoney(total);
        this.querySelector('[data-pair-total]').textContent = this.formatMoney(discountedTotal);
      }

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat(this.dataset.locale || 'en-US', {
            style: 'currency', currency: this.dataset.currency || 'USD'
          }).format(cents / 100);
        } catch (_) {
          return `${this.dataset.currency || 'USD'} ${(cents / 100).toFixed(2)}`;
        }
      }

      async submitPair(event) {
        event.preventDefault();
        if (this.pending || !this.form.reportValidity()) return;
        this.pending = true;
        const originalLabel = this.label.textContent;
        this.message.hidden = true;
        this.message.textContent = '';
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.label.textContent = this.dataset.addingLabel || 'Adding…';
        let added = false;
        const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const cartUrl = window.routes?.cart_url || '/cart';
        try {
          const pairGroup = window.crypto?.randomUUID?.() || `ap-${Date.now()}-${Math.random().toString(36).slice(2)}`;
          this.form.querySelectorAll('[data-pair-group]').forEach((input) => {
            input.value = pairGroup;
          });
          const data = new FormData(this.form);
          if (drawer?.getSectionsToRender) {
            data.append('sections', drawer.getSectionsToRender().map((section) => section.id).join(','));
            data.append('sections_url', window.location.pathname);
            drawer.setActiveElement?.(this.button);
          }
          const response = await fetch(this.form.action, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data
          });
          const state = await response.json();
          if (!response.ok || state.status) {
            throw new Error(typeof state.description === 'string' ? state.description : 'This pairing could not be added. Please check product availability.');
          }
          added = true;
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ap-pair-form', cartData: state })).catch(() => {});
          }
          if (drawer?.renderContents) drawer.renderContents(state);
          else window.location.assign(cartUrl);
        } catch (error) {
          if (added) {
            window.location.assign(cartUrl);
          } else {
            this.message.textContent = error instanceof TypeError
              ? 'We could not confirm the cart update. Check your cart before trying again.'
              : error.message || 'The cart could not be updated. Please try again.';
            this.message.hidden = false;
          }
        } finally {
          this.pending = false;
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
          this.label.textContent = originalLabel;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
